import { PromotionJson } from "@/types/Promotion.type";

export function checkPromotionInValid(promotions: PromotionJson[]) {
	return promotions.length > 0 && promotions.some((p) => p.status);
}
export function checkDealthom(promotions:PromotionJson[],product_id:number) {
	
}

